module.exports = __webpack_public_path__ + "static/babel-a2f36228d474093ce249316232fc3dd5.svg";